import React from 'react';
import ReactDOM from 'react-dom';
import thunk from "redux-thunk";
import { reactReduxFirebase, getFirebase } from "react-redux-firebase";
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { applyMiddleware, combineReducers, createStore, compose } from 'redux';
import { authReducer } from './store/auth';
import { Provider } from 'react-redux';
import firebase from './config/firebase';
import { reduxFirestore, getFirestore } from 'redux-firestore'
import { consultReducer } from './store/consult';


const reducer = combineReducers({
//  auth: authReducer,
  consult: consultReducer
})
const store = createStore(
  reducer,
  compose(
    applyMiddleware(thunk.withExtraArgument({ getFirebase, getFirestore })),
    reactReduxFirebase(firebase),
    reduxFirestore(firebase)

  )
);

ReactDOM.render(
  <Provider store={store}>

    <React.StrictMode>
      <App />
    </React.StrictMode>

  </Provider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
